<template>
  <b-link
    class="whatsapp"
    :href="destination"
  >
    <b-img
      width="70"
      src="@assets/images/whatsapp.svg"
      fluid
      alt="whatsapp"
    ></b-img>
  </b-link>
</template>

<script>

export default {
  name: "WhatsappButton",

  props: {
    destination: {
      type: String,
      default: null
    }
  },
}
</script>

<style scoped>
  .whatsapp {
    position: fixed;
    bottom: 30px;
    left: 30px;
    opacity: .85;
  }
</style>
